import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import masterIcon from '@master/master-icons';

// import '@/utils/log';
// 引入初始化函数
import installLogin, { plugin } from '@master/mg-omni';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { replaceToOriginStr } from '@/utils/tools';

// 引入登录组件样式
import '@master/mg-omni/dist/style.css';
// 引入swiper样式
import 'swiper/css/swiper.min.css';
import { sensors ,StatisticEventType} from '@/utils/log';


import { user_controller } from '@/api/controller/users';


Vue.use(installLogin);
Vue.use(masterIcon);
Vue.use(VueClipboard);
Vue.use(VueAwesomeSwiper);

plugin.initWeiXin(); // 初始化微信登录sdk

plugin.setLoginData();

Vue.prototype.$replaceToOriginStr = replaceToOriginStr;
Vue.prototype.$sensors = sensors;
Vue.prototype.$plugin = plugin;

export default async ({ app }) => {
  const server_env = app.store.state.app?.server_env?.CURRENT_ENV;
  if (server_env === 'pre' || server_env === 'prod') {
    console.log = function () {};
  }
  window.CURRENT_VERSION = app.store.state.app;
  try {
    app.store.dispatch('app/getBanners');
      await plugin
      .login()
      .then((res) => {
        app.store.commit('user/setUserInfo', res.data);
      })
      .catch(() => {
        app.store.commit('user/setUserInfo', { login_http_mark: true });
      });
    const settings = await user_controller.get_settings(app.$axios);
    app.store.commit('user/setColor', settings.data.color_schema);
    app.store.commit('user/setOrg', settings.data.currentOrg);

    app.store.state.err.errList.map((item) => {
      console.log('err', item);
      return item;
    });
  } catch (e) {
    app.store.commit('user/setColor');
    console.warn(e);
  }
  sensors.startActiveObsever({
    statistic: (e) => {
      const { startTime, endTime, pageUrl } = e.data.info;
      const urlInfo = app.router.match(new URL(pageUrl).pathname);
      const urlName = urlInfo?.name;
      // 活跃段统计完成，上报活跃统计事件
      if (e.data.tag === StatisticEventType.activeDuration) {
        const trackData = {
          action_parameter0: startTime,
          action_parameter1: endTime,
          url: pageUrl,
          url_name: urlName,
          url_path: urlName,
        };
        sensors.track('action_interaction', trackData);
      }
    },
  });
};
